import { useContext, useState } from "react"
import { SidePopupLayout } from "src/component/SidePopupLayout"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import { AppSpan, Button, CustomContainer, FlexRow, Form, FormGroup, FormGroupWithIcon, ScreenTitle } from "src/style"
import { FiChevronDown } from "react-icons/fi"
import { UssdBanks, UssdCodeDetails } from "src/component"

export const FundWithUssd: React.FC<any> = ({close}) => {
    const {notifier} = useContext(VisibilityContext)
    const [input, setInput] = useState({sourceAccount: '', amount: '', shouldSaveCard: false, cardDetails: {}, bank: '', ussdCode: ''})
    const [view, setView] = useState('fund-with-ussd')

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => setInput({...input, [e.target.name]: e.target.value})

    async function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        setView('ussd-banks')
    }

    async function handleSubmit() {
        notifier.show('Account Funded', null, 'success')
        close()
    }

    return (
        <>
            { view === 'fund-with-ussd' &&
                <SidePopupLayout close={close}>
                    <ScreenTitle textSize="2.2" fontWeight="700">Fund with USSD</ScreenTitle>
                    <CustomContainer topMargin='2.5'>
                        <AppSpan>Fund your account with the following options</AppSpan>
                        <Form onSubmit={handleProceed} topMargin='2'>
                            <FormGroup>
                                <label>Amount</label>
                                <input 
                                    placeholder='Enter Amount' 
                                    type='number'
                                    name='amount'
                                    value={input.amount}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    //required
                                />
                            </FormGroup>
                            <FormGroupWithIcon>
                                <label>Source Account</label>
                                <div className="input-with-icon">
                                    <select 
                                        placeholder="Source Account"
                                        name='sourceAccount'
                                        value={input.sourceAccount}
                                        style={{color: input.sourceAccount ? '#000000' : '#667085'}}
                                        onChange={handleInput}
                                        //required
                                    >
                                        <option value="">Select Account</option>
                                        <option value="2236728192">Qore - 2236728192</option>
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                            <FlexRow justifyContent='flex-end' topMargin='2.5'>
                                <Button 
                                    width='8.8' height='4' 
                                    borderColor='#0D968F' hoverBgColor='#fff' 
                                    hoverColor='#0D968F' titleSize='1.4'
                                >
                                    Proceed
                                </Button>
                            </FlexRow>
                        </Form>
                    </CustomContainer>
                </SidePopupLayout>
            }
            { view === 'ussd-banks' &&
                <UssdBanks 
                    close={close}
                    handleBank={(info: any) => setInput({...input, bank: info.bank, ussdCode: info.code})}
                    next={() => setView('ussd-code-details')}
                />
            }
            { view === 'ussd-code-details' &&
                <UssdCodeDetails 
                    close={close}
                    data={input}
                    handleConfirm={handleSubmit}
                    back={() => setView('ussd-banks')}
                />
            }
        </>
    )
}